// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomOption-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 8px 40px;
  align-items: flex-start;
}
.CustomOption-wrapper p {
  width: 100%;
  font-size: 14px;
  color: var(--color_neutral_800);
  text-align: start;
}
.CustomOption-wrapper .subLabel {
  font-size: 10px;
  color: var(--color_neutral_500);
}
.CustomOption-wrapper .TableTitleWithCheckbox-textHighlight {
  font-weight: 800;
  background-color: transparent;
}

.CustomOption-wrapper:hover {
  background-color: var(--color_primary_100);
}
.CustomOption-wrapper:hover p,
.CustomOption-wrapper:hover .subLabel,
.CustomOption-wrapper:hover .TableTitleWithCheckbox-textHighlight {
  color: var(--color_primary_500);
}`, "",{"version":3,"sources":["webpack://./src/components/SearchWithRecommendations/components/CustomOption/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;AACF;AACE;EACE,WAAA;EACA,eAAA;EACA,+BAAA;EACA,iBAAA;AACJ;AAEE;EACE,eAAA;EACA,+BAAA;AAAJ;AAGE;EACE,gBAAA;EACA,6BAAA;AADJ;;AAKA;EACE,0CAAA;AAFF;AAIE;;;EAGE,+BAAA;AAFJ","sourcesContent":[".CustomOption-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 8px 40px;\n  align-items: flex-start;\n\n  p {\n    width: 100%;\n    font-size: 14px;\n    color: var(--color_neutral_800);\n    text-align: start;\n  }\n\n  .subLabel {\n    font-size: 10px;\n    color: var(--color_neutral_500);\n  }\n\n  .TableTitleWithCheckbox-textHighlight {\n    font-weight: 800;\n    background-color: transparent;\n  }\n}\n\n.CustomOption-wrapper:hover {\n  background-color: var(--color_primary_100);\n\n  p,\n  .subLabel,\n  .TableTitleWithCheckbox-textHighlight {\n    color: var(--color_primary_500);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
